import { Avatar, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { SearchUsers } from 'screens/Admin/components';
import styled from 'styled-components';

const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'contentRemoved', label: 'Content Removed' },
  { value: 'ignored', label: 'Ignored' },
  { value: 'blocked', label: 'Blocked' },
  { value: 'unblocked', label: 'Unblocked' }
];

const ENTITY_TYPE_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'post', label: 'Post' },
  { value: 'story', label: 'Story' },
  { value: 'shoutout', label: 'Shoutout' },
  { value: 'fancam', label: 'FanCam' },
  { value: 'comment', label: 'Comment' },
  { value: 'user', label: 'User' },
  { value: 'fanchat', label: 'FanChat' },
  { value: 'fanchatTopic', labelKey: 'admin.reports.entityTypes.fanchatTopic' },
  { value: 'fanchatMessage', labelKey: 'admin.reports.entityTypes.fanchatMessage' }
];

const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid ${theme.GREY_20 || '#eee'};
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  min-width: 140px;
`;

const Filters = ({ owner, setOwner, entityType, setEntityType, status, setStatus }) => {
  const { t } = useTranslation();

  return (
    <Row start gap="30px" pad="12px 24px" noFlex>
      <Col>
        <Text marg="0 16px 4px" b2 med>
          Filter by reported
        </Text>

        <Row noFlex wid="427px">
          <SearchUsers
            placeholder="Search athletes, fans or teams..."
            selected={owner}
            handleSelect={setOwner}
            noRounded
          />

          {owner && (
            <Row start between wid="100%" center>
              <Row noFlex center>
                <Avatar small user={owner} />

                <Col marg="0 0 0 8px" noFlex>
                  <Text>{owner?.name}</Text>

                  <Text c1 col={theme.GREY_60}>
                    @{owner?.username}
                  </Text>
                </Col>
              </Row>

              <Clickable onClick={() => setOwner(null)}>
                <Icon type="close" dimensions={14} />
              </Clickable>
            </Row>
          )}
        </Row>
      </Col>

      <Col>
        <Text marg="0 16px 4px" b2 med>
          Filter by type
        </Text>

        <Select value={entityType} onChange={(e) => setEntityType(e.target.value)}>
          {ENTITY_TYPE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.labelKey ? t(opt.labelKey) : opt.label}
            </option>
          ))}
        </Select>
      </Col>

      <Col>
        <Text marg="0 16px 4px" b2 med>
          Filter by status
        </Text>

        <Select value={status} onChange={(e) => setStatus(e.target.value)}>
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default Filters;
